import * as React from "react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuGroup,
  DropdownMenuItem, DropdownMenuSeparator, DropdownMenuShortcut } from "./ui/dropdown-menu";

export interface MenuItem {
  label?: React.ReactNode;
  icon?: React.ReactNode;
  onClick?: () => void;
  /** @default "default" */
  tone?: "default" | "danger";
  shortcut?: string;
  disabled?: boolean;
  /** Render a divider line instead of an item. */
  divider?: boolean;
}

/** Action / context menu shown in a popover anchored to a trigger. */
export interface MenuProps {
  trigger: React.ReactElement;
  items: MenuItem[];
  /** Horizontal alignment to the trigger. @default "start" */
  align?: "start" | "end";
  width?: number;
  style?: React.CSSProperties;
}


export function Menu({trigger, items, align = "start", width = 200, style}: MenuProps) {
  return <span className="inline-flex" style={style}>
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align={align} style={{width}}>
        <DropdownMenuGroup>
          {items.map((item, index) => item.divider
            ? <DropdownMenuSeparator key={index} />
            : <DropdownMenuItem key={index} disabled={item.disabled === true}
                variant={item.tone === "danger" ? "destructive" : "default"} onSelect={() => item.onClick?.()}>
                {item.icon}<span className="flex-1">{item.label}</span>
                {item.shortcut && <DropdownMenuShortcut>{item.shortcut}</DropdownMenuShortcut>}
              </DropdownMenuItem>)}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  </span>;
}
